<template>
  <div>
    <v-layout row wrap class="pa-0 pb-1" v-if="currencyId == ''">
      <v-flex xs12 class="pa-0">
        <exchangeRateTable @setExchangeRates="setExchangeRates" />
      </v-flex>
    </v-layout>

    <v-layout row wrap class="pa-0 pb-1">
      <v-flex xs12 class="pa0">
        <accountingNumbers
          :subsidiaryId="subsidiaryId"
          :currencyId="currencyId || exchangeRatesBaseCurrencyID"
          :key="exchangeRatesBaseCurrencyID + currencyId + subsidiaryId"
        />
      </v-flex>
    </v-layout>

    <v-layout row wrap class="pa-0 pt-4">
      <v-flex xs12 class="pa-0">
        <bankInformationsCard
          :exchangeRates="exchangeRates"
          :exchangeRatesBaseCurrencyID="exchangeRatesBaseCurrencyID"
        />
      </v-flex>
    </v-layout>

    <receivablesPayables v-if="currencyId" :currencyId="currencyId" :subsidiaryId="subsidiaryId" />

    <v-layout row wrap class="pa-2" style="margin-bottom: 64px;">
      <v-flex xs12 lg6 class="px-2 py-2" d-flex v-if="currencyId">
        <accountTypeExpenses :currencyId="currencyId" :subsidiaryId="subsidiaryId" />
      </v-flex>

      <v-flex xs12 lg6 class="px-2 py-2" d-flex v-if="currencyId">
        <mtWeightGraph :subsidiaryId="subsidiaryId" />
      </v-flex>

     <!--  <v-flex xs12 class="px-2 py-2" d-flex>
        <capitalGraph
          :currencyId="currencyId"
          :subsidiaryId="subsidiaryId"
          :exchangeRates="exchangeRates"
          :exchangeRatesBaseCurrencyID="exchangeRatesBaseCurrencyID"
        />
      </v-flex> -->

      <!-- <v-flex xs12 sm12 md6 lg8 d-flex class="px-2 py-2">
        <cashFlow :currencyId="currencyId" :subsidiaryId="subsidiaryId"/>
      </v-flex>
      <v-flex xs12 sm12 md6 lg4 d-flex class="px-2 py-2">
        <topExpenses :currencyId="currencyId" :subsidiaryId="subsidiaryId"/>
      </v-flex>-->

      <v-flex xs12 sm12 md6 lg6 d-flex class="px-2 py-2" v-if="currencyId">
        <latestInvoices
          :currencyId="currencyId"
          :subsidiaryId="subsidiaryId"
          @changeTab="changeTab"
        />
      </v-flex>
      <v-flex xs12 sm12 md6 lg6 d-flex class="px-2 py-2" v-if="currencyId">
        <latestTransactions
          :currencyId="currencyId"
          :subsidiaryId="subsidiaryId"
          @changeTab="changeTab"
        />
      </v-flex>
    </v-layout>
    <v-footer app inset fixed height="64" color="white">
      <equity :currencyId="currencyId" :subsidiaryId="subsidiaryId" :exchangeRatesBaseCurrencyID="exchangeRatesBaseCurrencyID"/>
    </v-footer>
  </div>
</template>

<script>
import accountingNumbers from "./accountingNumbers";
import bankInformationsCard from "./bankInformationsCard";
import receivablesPayables from "./receivablesPayables";
import cashFlow from "./cashFlow";
import topExpenses from "./topExpenses";
import accountTypeExpenses from "./accountTypeExpenses";
import mtWeightGraph from "./mtWeightGraph";
import capitalGraph from "./capitalGraph";
import exchangeRateTable from "./exchangeRateTable";
import latestTransactions from "./latestTransactions";
import latestInvoices from "./latestInvoices";
import equity from "./equity";
import { mapGetters } from "vuex";

export default {
  props: {
    currencyId: {
      type: String,
      required: true,
    },
    subsidiaryId: {
      type: String,
      required: false,
      default: "",
    },
  },
  components: {
    bankInformationsCard,
    accountingNumbers,
    cashFlow,
    equity,
    latestInvoices,
    latestTransactions,
    receivablesPayables,
    topExpenses,
    accountTypeExpenses,
    mtWeightGraph,
    capitalGraph,
    exchangeRateTable,
  },
  data() {
    return {
      exchangeRates: [],
      exchangeRatesBaseCurrencyID: "",
    };
  },
  computed: {
    ...mapGetters("commonStore", ["currencies"]),
  },
  methods: {
    setExchangeRates(exchangeRates, exchangeRatesBaseCurrencyID) {
      this.exchangeRates = exchangeRates;
      this.exchangeRatesBaseCurrencyID = exchangeRatesBaseCurrencyID;
    },
    changeTab(tab) {
      this.$emit("changeTab", tab);
    },
  },
};
</script>
